import { DataGrid, GridRowsProp, GridColDef } from "@mui/x-data-grid";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { BsXCircle } from "react-icons/bs";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "../../assets/css/main.css";
import { DAILY, MONTHLY, WEEKLY } from "../../common/constant";
import {
  customStyles,
  headerContainerStyle,
  headerStyle,
  iconStyle,
  prizeNameStyle,
  selectStyle,
  titleStyle,
} from "../../common/resultDetailStyle";
import {
  addDayToTimeNow,
  convertDateToString,
  getFirstDayOfMonth,
  getFirstDayOfWeek,
  getLastDayOfWeek,
  isNotNull,
} from "../../common/utils";
import { restGetApi, restPostApi } from "../../services/httpService";
import {
  buyTurnConfirmUrl,
  loadMonthlyResultUrl,
  loadResultUrl,
  loadResultWinnerUrl,
} from "../../common/url";
import { useDispatch, useSelector } from "react-redux";
import { error, httpSuccess, success } from "../../common/errorCode";
import { store } from "../..";
import { setDataToModal } from "../../actions/modal";

const ResultWinner = ({ prizeInfo, isOpenModal, setIsOpenModal }) => {
  const tokenInfo = useSelector((state) => state.SessionReducer);
  const dispatch = useDispatch();
  const [winnerData, setWinnerData] = React.useState({});

  function closeModal() {
    setIsOpenModal(false);
  }

  React.useEffect(() => {
    // load winner
    console.log("winnerId: " + prizeInfo.winnerCodeId);
    loadResultWinner(prizeInfo.winnerCodeId);
  }, []);

  async function loadResultWinner(winnerId) {
    console.log("winnerId: " + winnerId);
    let res = await restPostApi(
      loadResultWinnerUrl,
      {
        winnerCodeId: winnerId,
      },
      tokenInfo
    );

    console.log("res: " + JSON.stringify(res));

    if (res != null) {
      console.log("status: " + res.status);

      let errorCode = error;
      let message = "ERROR";
      if (res.status === httpSuccess) {
        console.log("errorCode: " + res.data.errorCode);
        errorCode = res.data.errorCode;
        if (res.data.errorCode === success) {
          setWinnerData(res.data.data.winnerData);
          return;
        } else {
          console.log("message: " + res.data.message);
          message = res.data.message;
        }
      }
      store.dispatch(
        setDataToModal({
          type: "result",
          dataToModal: {
            errorCode: errorCode,
            message: message,
          },
        })
      );
    }
  }

  return (
    <div>
      <Modal
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Result winner Modal"
      >
        <div style={headerContainerStyle}>
          <div style={iconStyle} onClick={closeModal}>
            <BsXCircle style={{ height: "2rem", width: "2rem" }} />
          </div>
        </div>
        <div style={titleStyle}>
          <div style={headerStyle}>
            <div style={{ padding: "10px 0px" }}>WINNER INFORMATION</div>
          </div>
          <div className="prize-month-name">
            <div style={{ padding: "10px 0px" }}>
              {prizeInfo.name.toUpperCase()}
            </div>
          </div>
          {(() => {
            if (isNotNull(winnerData)) {
              let dataRender = [];
              for (let i = 0; i < winnerData.length; i++) {
                dataRender.push(
                  <div className="prize-box-info">
                    <div className="row" style={{ padding: "10px 0px" }}>
                      <div className="col-6 prize-title">Date</div>
                      <div className="col-6">{winnerData[i].date}</div>
                    </div>
                    <div className="row" style={{ padding: "10px 0px" }}>
                      <div className="col-6 prize-title">Winner</div>
                      <div className="col-6">{winnerData[i].msisdn}</div>
                    </div>
                  </div>
                );
              }
              return dataRender;
            }
            return (
              <div>
                <div className="prize-month-name">
                  <div style={{ padding: "10px 0px" }}>No WINNER</div>
                </div>
              </div>
            );
          })()}
        </div>
      </Modal>
    </div>
  );
};

export default ResultWinner;
